import React from "react";
import { Router, Switch } from "react-router-dom";
import {
  Home,
  Checkout,
  List,
  OrderDetails,
  OrderSummary,
  ProductDetail,
  CompleteRegistration,
  ErrorPage,
  Policy,
  OldOrderDetail,
  UserOrders,
  SearchResultPage,
  Cookies,
  MaintenancePage,
} from "./components";
import {
  PrimaryNavigation,
  SecondaryNavigation,
  Footer,
} from "./components/common";
import { PageWrapperStyle, PageContainterStyle } from "./utils/style-utils";
import RedirectRoute from "./utils/RedirectRoute";
import RedirectRouteAnonymous from "./utils/RedirectRouteAnonymous";
import RedirectRouteCompleteRegistration from "./utils/RedirectRouteCompleteRegistration";
import { connect } from "react-redux";
import { theme } from "dab-component-lib";
import createHistory from "history/createBrowserHistory";
import { ThemeProvider } from "styled-components";
import { toggleMenu } from "./actions/index";
import { checkAndInject } from "./utils/GTMUtils";

export const history = createHistory();

class Main extends React.Component {
  closeMenu() {
    const { openMenu, dispatch } = this.props;
    if (openMenu.value) {
      dispatch(toggleMenu(false));
    }
  }

  componentDidMount() {
    checkAndInject();
  }

  render() {
    const { openMenu } = this.props;

    const isMaintenance = history.location.pathname === "/maintenance";

    return (
      <Router history={history}>
        <ThemeProvider theme={theme}>
          <PageWrapperStyle
            openMenu={openMenu.value}
            onClick={() => this.closeMenu()}
          >
            <PageContainterStyle>
              {isMaintenance ? null : <PrimaryNavigation />}
              {isMaintenance ? null : <SecondaryNavigation />}
              <Switch>
                <RedirectRoute exact path="/" component={Home} />
                <RedirectRouteAnonymous
                  exact
                  path="/checkout"
                  component={Checkout}
                />
                <RedirectRouteAnonymous
                  exact
                  path="/order-details"
                  component={OrderDetails}
                />
                <RedirectRouteAnonymous
                  exact
                  path="/order-summary"
                  component={OrderSummary}
                />
                <RedirectRoute
                  exact
                  path="/category/:category"
                  component={List}
                />
                {/* <RedirectRoute exact path="/summary" component={Summary} /> */}
                <RedirectRoute
                  exact
                  path="/product-detail/:id"
                  component={ProductDetail}
                />
                <RedirectRouteCompleteRegistration
                  exact
                  path="/complete-registration"
                  component={CompleteRegistration}
                />
                <RedirectRoute exact path="/403" component={ErrorPage} />
                <RedirectRoute exact path="/404" component={ErrorPage} />
                <RedirectRoute exact path="/policy" component={Policy} />
                <RedirectRoute
                  exact
                  path="/maintenance"
                  component={MaintenancePage}
                />
                <RedirectRouteAnonymous
                  exact
                  path="/old-order-detail/:id"
                  component={OldOrderDetail}
                />
                <RedirectRouteAnonymous
                  exact
                  path="/user-orders"
                  component={UserOrders}
                />
                <RedirectRoute
                  exact
                  path="/search-results"
                  component={SearchResultPage}
                />
                <RedirectRoute exact path="/cookies" component={Cookies} />
              </Switch>
            </PageContainterStyle>
            {isMaintenance ? null : <Footer />}
          </PageWrapperStyle>
        </ThemeProvider>
      </Router>
    );
  }
}

const mapStateToProps = ({ openMenu }) => {
  return {
    openMenu,
  };
};

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/Main.js